/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getEspecialties } from 'app/entities/especialty/especialty.reducer';
import { getEntities as getDepartments } from 'app/entities/department/department.reducer';
import { createEntity, getEntity, reset, updateEntity } from './department-speciality.reducer';

export const DepartmentSpecialityUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const especialties = useAppSelector(state => state.especialty.entities);
  const departments = useAppSelector(state => state.department.entities);
  const departmentSpecialityEntity = useAppSelector(state => state.departmentSpeciality.entity);
  const loading = useAppSelector(state => state.departmentSpeciality.loading);
  const updating = useAppSelector(state => state.departmentSpeciality.updating);
  const updateSuccess = useAppSelector(state => state.departmentSpeciality.updateSuccess);

  const handleClose = () => {
    navigate(`/department-speciality${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getEspecialties({}));
    dispatch(getDepartments({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdate !== undefined && typeof values.lastUpdate !== 'number') {
      values.lastUpdate = Number(values.lastUpdate);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...departmentSpecialityEntity,
      ...values,
      speciality: especialties.find(it => it.id.toString() === values.speciality?.toString()),
      department: departments.find(it => it.id.toString() === values.department?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...departmentSpecialityEntity,
          speciality: departmentSpecialityEntity?.speciality?.id,
          department: departmentSpecialityEntity?.department?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.departmentSpeciality.home.createOrEditLabel" data-cy="DepartmentSpecialityCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.departmentSpeciality.home.createOrEditLabel">
              Create or edit a DepartmentSpeciality
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="department-speciality-id"
                  label={translate('tinyMedicRestApp.departmentSpeciality.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentSpeciality.active')}
                id="department-speciality-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentSpeciality.cursor')}
                id="department-speciality-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentSpeciality.lastUpdate')}
                id="department-speciality-lastUpdate"
                name="lastUpdate"
                data-cy="lastUpdate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentSpeciality.microSec')}
                id="department-speciality-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentSpeciality.timestampEntry')}
                id="department-speciality-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="department-speciality-speciality"
                name="speciality"
                data-cy="speciality"
                label={translate('tinyMedicRestApp.departmentSpeciality.speciality')}
                type="select"
              >
                <option value="" key="0" />
                {especialties
                  ? especialties.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="department-speciality-department"
                name="department"
                data-cy="department"
                label={translate('tinyMedicRestApp.departmentSpeciality.department')}
                type="select"
              >
                <option value="" key="0" />
                {departments
                  ? departments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/department-speciality" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DepartmentSpecialityUpdate;
